module.exports = __webpack_public_path__ + "static/media/upload.113f29a1.svg";